import { negToUint8, parseHexArray } from "@/common/index";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";

const reportParams = (value) => {
  value = value.replace(/[^0-9a-fA-F]/g, "");
  let data = parseHexArray(value);
  let reportId = data.getUint8(0);
  let reportData = new Uint8Array(data.buffer).slice(1);
  return {
    reportId,
    reportData,
  };
};
const getCheckSum = (strData, maxSize = 63) => {
  strData = strData.replace(/[^0-9a-fA-F]/g, "");

  let data = parseHexArray(strData);

  let pDataArray = new Uint8Array(data.buffer).slice(1);

  let sum = 0;
  for (let i = 0; i < maxSize; i++) {
    sum += pDataArray[i];
  }
  sum %= 256;
  // console.log("sum", sum);
  let value = parseInt("A1", 16) - sum;

  // console.log(value.toString(16))
  value = value >= 0 ? value : negToUint8(value);

  return value.toString(16).padStart(2, "0");
};

export const send_update = async (send_data, byte = "1d", byte0 = "9e") => {
 
  return new Promise((resolve, reject) => {
    const main = useStore();
    const { device, appRNG, appUpdateData, dfuData, dfuData1 } =
      storeToRefs(main);
    const byte1 = byte;
   
    enter_dfu(byte1, send_data);

 
    let timer2 = setInterval(() => {
      if (dfuData.value.length) {
        senddfu_hexinfo(byte1, send_data, dfuData.value);
        clearInterval(timer2);
      }
    });
  
    
    let timer3 = setInterval(() => {
      if (dfuData1.value.length) {
        send_bag3(byte1, send_data);
        console.log(2)
        clearInterval(timer3);
      }
    });
    
    let timer4 = setInterval(() => {
      if (appRNG.value.length) {
        send();
       
        clearInterval(timer4);
      }
    });

    
    let hex = "";
    for (let i = 15; i >= 12; i--) {
      hex += send_data[i].padStart(2, "0");
    }
    const maxByte = 73 + parseInt(hex, 16);
    const data = new Array(63).fill("00");
    data[1] = "-1";
    data[0] = byte0;
    let i = 74;
    let j = 4;
    let count = 0;
    // 发送bin文件数据包
    async function send() {
      for (let k = 4; k < 63; k++) {
        data[k] = "00";
      }
      for (j = 4; j < 63; j++) {
        data[j] = send_data[i++].toString(16).padStart(2, "0");
        if (i > maxByte) {
          j++;
          break;
        }
      }
      if (j !== 63) {
        data[3] = "93";
      } else {
        data[3] = "3b";
      }

      data[2] =
        data[1].toLowerCase() === "ff" ? parseInt(data[2], 16) + 1 : data[2];
      data[1] =
        data[1].toLowerCase() === "ff" ? "00" : parseInt(data[1], 16) + 1;
      data[2] = data[2].toString(16).padStart(2, "0");
      data[1] = data[1].toString(16).padStart(2, "0");

      const str = "00" + data.join("");
      let { reportId, reportData } = reportParams(str + getCheckSum(str));
      await device.value.sendReport(reportId, reportData);
    }
    // setTimeout(() => {
    //   send();
    // }, 400);

    let timer = setInterval(async () => {
      if (
        appUpdateData.value.length &&
        appUpdateData.value[2].toLowerCase() === data[1].toLowerCase() &&
        appUpdateData.value[3].toLowerCase() === data[2].toLowerCase()
      ) {
        count++;
        const percentage = Math.ceil(
          (count / Math.ceil((maxByte - 73) / 59)) * 100
        );
        main.getUpdatePercentage(percentage);
        send();
        if (i > maxByte) {
          clearInterval(timer);
          setTimeout(() => {
            send_end_data(
              appRNG.value,
              byte1,
              send_data[20].padStart(2, "0"),
              send_data[21].padStart(2, "0")
            );
          }, 100);
          setTimeout(() => {
            resolve();
          }, 200);
        }
      }
    });
  });
};

//进入dfu状态  1d 00 8b 01 (f0 07 00 00)hexPID     无线  1d 00 8b 01   d0 07
export const enter_dfu = async (byte1, bin_data) => {
  const main = useStore();
  const { device, mouseData } = storeToRefs(main);
  const data = new Array(63).fill("00");
  data[0] = byte1;
  data[2] = "8b";
  data[3] = "01";

  data[4] = bin_data[0].padStart(2, "0");
  data[5] = bin_data[1].padStart(2, "0");
  data[6] = bin_data[2].padStart(2, "0");
  data[7] = bin_data[3].padStart(2, "0");

  const value = "00" + data.join("");
  const { reportId, reportData } = reportParams(value + getCheckSum(value));
  console.log("value", value + getCheckSum(value));
  await device.value.sendReport(reportId, reportData);
};

//  1d 00 8d 02   cc 6c c0 52 54    （44 9e f5 82 6f 4e 4d） rng_key
//  1d 00 8d 02   91 49 03 52 e7     (1f 7a 99 3e 2f 78 8a)   无线
const senddfu_hexinfo = async (byte1, bin_data, dfuData) => {
  const main = useStore();
  const { device } = storeToRefs(main);
  const data = new Array(63).fill("00");
  data[0] = byte1;
  data[2] = "8d";
  data[3] = "02";

  data[4] = dfuData[6].padStart(2, "0");
  data[5] = dfuData[7].padStart(2, "0");
  data[6] = dfuData[8].padStart(2, "0");
  data[7] = dfuData[9].padStart(2, "0");
  data[8] = dfuData[10].padStart(2, "0");

  data[9] = bin_data[66].padStart(2, "0");
  data[10] = bin_data[67].padStart(2, "0");
  data[11] = bin_data[68].padStart(2, "0");
  data[12] = bin_data[69].padStart(2, "0");
  data[13] = bin_data[70].padStart(2, "0");
  data[14] = bin_data[71].padStart(2, "0");
  data[15] = bin_data[72].padStart(2, "0");
  const value = "00" + data.join("");
  const { reportId, reportData } = reportParams(value + getCheckSum(value));
  await device.value.sendReport(reportId, reportData);
};
//1d 00 8d 06 00  (00 70 02 00)sd_start  (00 60 01 00)aPP_size   (dc c5 20 5c) app_crc
//1d 00 8d 06 00     24 00 00  00 74 00 00   91 a7 16 4e 无线
const send_bag3 = async (byte1, bin_data) => {
  const main = useStore();
  const { device } = storeToRefs(main);
  const data = new Array(63).fill("00");
  data[0] = byte1;
  data[2] = "8d";
  data[3] = "06";

  data[4] = bin_data[36].padStart(2, "0");
  data[5] = bin_data[37].padStart(2, "0");
  data[6] = bin_data[38].padStart(2, "0");
  data[7] = bin_data[39].padStart(2, "0");

  data[8] = bin_data[12].padStart(2, "0");
  data[9] = bin_data[13].padStart(2, "0");
  data[10] = bin_data[14].padStart(2, "0");
  data[11] = bin_data[15].padStart(2, "0");

  data[12] = bin_data[16].padStart(2, "0");
  data[13] = bin_data[17].padStart(2, "0");
  data[14] = bin_data[18].padStart(2, "0");
  data[15] = bin_data[19].padStart(2, "0");

  const value = "00" + data.join("");
  const { reportId, reportData } = reportParams(value + getCheckSum(value));
  await device.value.sendReport(reportId, reportData);
};

// bin文件数据包发送完,结尾的包
// byte2和byte3两个字节代表,升级包得版本号  byte1表示是dongle升级还是鼠标升级
const send_end_data = async (CheckData, byte1, byte2, byte3) => {
  const main = useStore();
  const { device } = storeToRefs(main);
  const data = new Array(63).fill("00");
  data[0] = byte1;
  data[2] = "88";
  data[3] = "07";

  const array = CheckData.slice(5, 10).map((item) => parseInt(item, 16));
  data[5] = ((array[0] + array[1]) ^ array[4]) & 255;
  data[6] = ((array[1] + array[2]) ^ array[3]) & 255;
  data[7] = ((array[4] + array[3]) ^ array[1]) & 255;
  data[8] = ((array[3] + array[4]) ^ array[0]) & 255;
  for (let i = 5; i <= 8; i++) {
    data[i] = data[i].toString(16).padStart(2, "0");
  }

  data[9] = byte2;
  data[10] = byte3;

  const value = "00" + data.join("");
  const { reportId, reportData } = reportParams(value + getCheckSum(value));
  await device.value.sendReport(reportId, reportData);
};

